import { mapMedicationRowToValues } from '../../../../common';
import { MEDICATION_FORM_SCHEMA } from './validationSchema';

import type { ITreatmentPlanV3MedicationPage } from '../../../../../store/treatmentPlanV3';

export function hasMedicationFormErrors(page: ITreatmentPlanV3MedicationPage) {
  if (page.no_medication) return false;
  if (page.medications.length === 0) return true;
  return page.medications.some(
    (row) => !MEDICATION_FORM_SCHEMA.isValidSync(mapMedicationRowToValues(row)),
  );
}
